export interface LoadScriptResult {
  script: HTMLScriptElement;
  isNew: boolean;
}

export function loadScript(src: string): Promise<LoadScriptResult> {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);

    if (existing) {
      resolve({ script: existing, isNew: false });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve({ script, isNew: true });
    script.onerror = () => reject(new Error(`Failed to load ${src}`));

    document.body.appendChild(script);
  });
}
